import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'kyc',
  namespaced: true,
  actions: {
    async addCdd({}, cdd) {
      const { data } = await defaultApi.postCdd({
        data: {
          cdd,
        },
      })
      return data
    },
    async addEdd({}, edd) {
      const { data } = await defaultApi.postEdd({
        data: {
          edd,
        },
      })
      return data
    },
    async getMobileAuthUrl({}, { redirectPage }) {
      const { data } = await defaultApi.postMobileAuthUrl({
        redirectPage,
      })
      return data
    },
    async getMobileAuthUrlResult({}) {
      const { data } = await defaultApi.postMobileAuthUrlResult()
      return data
    },
    async addResidentRegistrationCertificate({}, resident) {
      const { data } = await defaultApi.postVerifyResidentRegistrationCertificate(resident)
      return data
    },
    async addDriverLicense({}, driverLicense) {
      const { data } = await defaultApi.postVerifyDriverLicense(driverLicense)
      return data
    },
  },
}
